import { graphql } from 'app/generated/gql'

// The confirmation lives on the Workspace (TRK-5807): a date and the confirming user's id, and
// confirming again overwrites both. "Has this workspace confirmed?" is therefore a read of that
// date, and the API serves no wording; the copy is smsConsentText.ts.
export const WORKSPACE_CONSENT_QUERY = graphql(`
  query WorkspaceSmsConsent($id: ID!) {
    workspace(id: $id) {
      id
      name
      marketingConsentConfirmedDate
    }
  }
`)

export const CONFIRM_MARKETING_CONSENT_MUTATION = graphql(`
  mutation ConfirmMarketingConsent {
    confirmMarketingConsent {
      id
      marketingConsentConfirmedDate
      marketingConsentConfirmedByUserId
    }
  }
`)
